
import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  InputAdornment,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
  TablePagination,
} from "@mui/material";
import {
  Search as SearchIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  HourglassEmpty as PendingIcon,
  Visibility as VisibilityIcon,
  Description as DocumentIcon,
} from "@mui/icons-material";


const dummyData = [
  {
    loginId: "U1001",
    name: "Alice Smith",
    mobile: "9876543210",
    idProof: "ABCDE1234F",
    addressProof: "Aadhar",
    addressProofBack: "Aadhar Back",
    bankDetailsAdhar: "Adhar Back",
    bankDetailsPassbook: "Passbook",
    status: "Pending",
  },
  {
    loginId: "U1002",
    name: "Bob Brown",
    mobile: "9123456780",
    idProof: "XYZAB5678K",
    addressProof: "DL",
    addressProofBack: "DL Back",
    bankDetailsAdhar: "DL Back",
    bankDetailsPassbook: "Cheque Leaf",
    status: "Pending",
  },
];

const KYCApproval = () => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState(dummyData);
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(0);
  };

  const handleViewDocument = (doc) => {
    setSelectedDocument(doc);
    setViewDialogOpen(true);
  };

  const handleApprove = (row) => {
    if (window.confirm(`Are you sure you want to approve KYC for ${row.name}?`)) {
      setData(data.map(item => item.loginId === row.loginId ? { ...item, status: "Approved" } : item));
    }
  };
  
  const handleReject = (row) => {
    if (window.confirm(`Are you sure you want to reject KYC for ${row.name}?`)) {
      setData(data.map(item => item.loginId === row.loginId ? { ...item, status: "Rejected" } : item));
    }
  };

  const filteredData = data.filter(
    row =>
      row.loginId.toLowerCase().includes(search.toLowerCase()) ||
      row.name.toLowerCase().includes(search.toLowerCase()) ||
      row.mobile.includes(search)
  );

  const getFilteredByStatus = () => {
    if (tabValue === 0) return filteredData; // All
    if (tabValue === 1) return filteredData.filter(row => row.status === "Pending"); // Pending
    if (tabValue === 2) return filteredData.filter(row => row.status === "Approved"); // Approved
    if (tabValue === 3) return filteredData.filter(row => row.status === "Rejected"); // Rejected
    return filteredData;
  };

  const displayData = getFilteredByStatus();
  const pendingCount = data.filter(row => row.status === "Pending").length;
  const approvedCount = data.filter(row => row.status === "Approved").length;
  const rejectedCount = data.filter(row => row.status === "Rejected").length;

  return (
  <Box sx={{ p: 3, backgroundColor: '#fafafa', minHeight: 'auto' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
          KYC Approval Management
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Review and approve associate KYC documents
        </Typography>
      </Box>

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%', backgroundColor: '#ffffff' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#e3f2fd',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <DocumentIcon sx={{ color: '#1976d2', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {data.length}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Applications
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%', backgroundColor: '#ffffff' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#fff3e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PendingIcon sx={{ color: '#f57c00', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {pendingCount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Pending Review
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%', backgroundColor: '#ffffff' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#e8f5e9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <CheckCircleIcon sx={{ color: '#2e7d32', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {approvedCount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Approved
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%', backgroundColor: '#ffffff' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#ffebee',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <CancelIcon sx={{ color: '#c62828', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {rejectedCount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Rejected
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search Bar */}
      <Card sx={{ mb: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, backgroundColor: '#ffffff' }}>
        <CardContent>
          <TextField
            fullWidth
            placeholder="Search by Login ID, Name, or Mobile"
            value={search}
            onChange={handleSearchChange}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              }
            }}
          />
        </CardContent>
      </Card>

      {/* Tabs and Table */}
      <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, backgroundColor: '#ffffff' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={(e, newValue) => {
              setTabValue(newValue);
              setPage(0);
            }}
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '15px',
                minHeight: 56
              }
            }}
          >
            <Tab label={`All Applications (${data.length})`} />
            <Tab label={`Pending (${pendingCount})`} />
            <Tab label={`Approved (${approvedCount})`} />
            <Tab label={`Rejected (${rejectedCount})`} />
          </Tabs>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Associate Info</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Documents</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Status</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, idx) => (
                  <TableRow 
                    key={row.loginId}
                    sx={{
                      '&:hover': { backgroundColor: '#f9fafb' },
                      '& td': { py: 2 }
                    }}
                  >
                    <TableCell sx={{ fontWeight: 600, color: '#000' }}>
                      {page * rowsPerPage + idx + 1}
                    </TableCell>
                    <TableCell>
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#000' }}>
                          {row.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {row.loginId} • {row.mobile}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" flexWrap="wrap" gap={0.5}>
                        <Tooltip title="PAN Card">
                          <Chip 
                            label="PAN" 
                            size="small" 
                            variant="outlined"
                            onClick={() => handleViewDocument({ type: 'PAN Card', value: row.idProof })}
                            sx={{ cursor: 'pointer', fontSize: '11px' }}
                          />
                        </Tooltip>
                        <Tooltip title="Address Proof Front">
                          <Chip 
                            label="Address" 
                            size="small" 
                            variant="outlined"
                            onClick={() => handleViewDocument({ type: 'Address Proof', value: row.addressProof })}
                            sx={{ cursor: 'pointer', fontSize: '11px' }}
                          />
                        </Tooltip>
                        <Tooltip title="Address Proof Back">
                          <Chip 
                            label="Back" 
                            size="small" 
                            variant="outlined"
                            onClick={() => handleViewDocument({ type: 'Address Proof Back', value: row.addressProofBack })}
                            sx={{ cursor: 'pointer', fontSize: '11px' }}
                          />
                        </Tooltip>
                        <Tooltip title="Bank Document">
                          <Chip 
                            label="Bank" 
                            size="small" 
                            variant="outlined"
                            onClick={() => handleViewDocument({ type: 'Bank Details', value: row.bankDetailsPassbook })}
                            sx={{ cursor: 'pointer', fontSize: '11px' }}
                          />
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={row.status} 
                        size="small"
                        color={
                          row.status === 'Approved' ? 'success' : 
                          row.status === 'Rejected' ? 'error' : 'warning'
                        }
                        sx={{ fontWeight: 600, fontSize: '12px' }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Box display="flex" justifyContent="center" gap={1}>
                        <Tooltip title="Approve KYC">
                          <span>
                            <IconButton
                              color="success"
                              size="small"
                              onClick={() => handleApprove(row)}
                              disabled={row.status === "Approved" || row.status === "Rejected"}
                            >
                              <CheckCircleIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Reject KYC">
                          <span>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => handleReject(row)}
                              disabled={row.status === "Approved" || row.status === "Rejected"}
                            >
                              <CancelIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        <TablePagination
          
          component="div"
          count={displayData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ borderTop: '1px solid #e0e0e0' }}
        />
      </Card>

      {/* View Document Dialog */}
      <Dialog 
        open={viewDialogOpen} 
        onClose={() => setViewDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {selectedDocument?.type}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <DocumentIcon sx={{ fontSize: 80, color: '#536DFE', mb: 2 }} />
            <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
              Document Number
            </Typography>
            <Typography variant="h6" color="primary">
              {selectedDocument?.value}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
              In a real application, this would display the actual document image
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setViewDialogOpen(false)}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default KYCApproval;